import type { Severity } from "@/lib/api";

const STYLES: Record<Severity, { label: string; className: string }> = {
  BLOCKER: {
    label: "Blocker",
    className: "bg-atlas-danger/10 text-atlas-danger border-atlas-danger/30",
  },
  WARN: {
    label: "Warn",
    className: "bg-atlas-warn/10 text-atlas-warn border-atlas-warn/30",
  },
  INFO: {
    label: "Info",
    className: "bg-atlas-mist text-atlas-ink border-atlas-slate/25",
  },
};

export function SeverityBadge({ level }: { level: Severity }) {
  const s = STYLES[level];
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-2xs font-medium ${s.className}`}
    >
      {s.label}
    </span>
  );
}
